export const initialState = {
  practiceId: '',
  departmentId: null,
};
